import type {ManifestActionValue} from '../actions/types'

export abstract class DisplayFiltersActions {
    protected abstract getHiddenActions(): Record<string, ManifestActionValue>

    private getHiddenFilters = (): string[] => {
        return Object.keys(this.getHiddenActions())
    }

    public build = () => {
        const hiddenFilters = this.getHiddenFilters()

        if (hiddenFilters.length === 0) {
            return undefined
        }

        return {
            hide: hiddenFilters
        }
    }
}
